import React from "react";

import { isDarkTheme, useTheme } from "../../../src/routes/WebDashboardViewer/themes";

export enum TooltipDirection {
  Up = "up",
  Down = "down",
  Left = "left",
  Right = "right",
}
interface TooltipProps {
  direction: TooltipDirection;
  children: React.ReactNode;
  showTooltip: boolean;
}

export const Tooltip: React.FC<TooltipProps> = (props: TooltipProps) => {
  const theme = useTheme();
  const useDarkTheme = isDarkTheme(theme.themeId);

  let positionClass;
  switch (props.direction) {
    case TooltipDirection.Up:
      positionClass = "bottom-full mb-[.5rem]";
      break;
    case TooltipDirection.Right:
      positionClass = "left-full ml-[.5rem]";
      break;
    case TooltipDirection.Down:
      positionClass = "top-full mt-[.5rem]";
      break;
    case TooltipDirection.Left:
      positionClass = "right-full mr-[.5rem]";
      break;
  }
  const bgClass = useDarkTheme ? "bg-white" : "bg-[#111215]";
  const textColorClass = useDarkTheme ? "text-black" : "text-white";

  return props.showTooltip ? (
    <div className="w-full h-full absolute flex justify-center items-center">
      <div
        className={`rounded-lg text-lg font-semibold absolute ${positionClass} w-max mx-auto p-2 ${bgClass} ${textColorClass}`}
      >
        {props.children}
      </div>
    </div>
  ) : null;
};
